import {
    RECEIVE_PRODUCT_BUNDLE_REASONS,
    REMOVE_PRODUCT_BUNDLE_REASON,
    REQUEST_PRODUCT_BUNDLE_REASONS,
} from '../actions'
import { removeItemsById, updateOrAddItemsById } from '../helpers'

const initialState = {
    isFetching: null,
    fetchSuccessful: null,
    items: [],
}

export default (state = initialState, action) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PRODUCT_BUNDLE_REASONS:
            return { ...state, isFetching: true }

        case RECEIVE_PRODUCT_BUNDLE_REASONS: {
            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems: data.items })
            return { ...state, ...data, items, isFetching: false }
        }

        case REMOVE_PRODUCT_BUNDLE_REASON: {
            const items = removeItemsById({ currentItems: state.items, id: data.id })

            return { ...state, ...data, items, isFetching: false }
        }

        default:
            return state
    }
}
